/* ==========================================================================
   Cart Offer Popup / Warning + Progress Bar
   AUJ · aujjessa.com

   Reads every setting from the data-cart-offer-config attribute on
   [data-cart-offer-root], so this file never needs editing per store.

   Debug: run  window.CART_OFFER_DEBUG = true  then reload.
   Preview the celebration any time with  cartOfferCelebrate()
   ========================================================================== */

(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-cart-offer-root]');
    if (!root || root.dataset.cartOfferReady === '1') return;
    root.dataset.cartOfferReady = '1';

    var cfg;
    try { cfg = JSON.parse(root.getAttribute('data-cart-offer-config')); }
    catch (e) { return; }

    function log() {
      if (!window.CART_OFFER_DEBUG) return;
      console.log.apply(console, ['[cart-offer]'].concat([].slice.call(arguments)));
    }

    var el = {
      message:       root.querySelector('[data-cart-offer-message]'),
      sub:           root.querySelector('[data-cart-offer-sub]'),
      count:         root.querySelector('[data-cart-offer-count]'),
      bar:           root.querySelector('[data-cart-offer-progress]'),
      fill:          root.querySelector('[data-cart-offer-fill]'),
      slots:         root.querySelector('[data-cart-offer-slots]'),
      cta:           root.querySelector('[data-cart-offer-cta]'),
      ctaLabel:      root.querySelector('[data-cart-offer-cta-label]'),
      close:         root.querySelector('[data-cart-offer-close]'),
      confettiFront: root.querySelector('[data-cart-offer-confetti]'),
      confettiBack:  root.querySelector('[data-cart-offer-confetti-back]')
    };

    var STORE_IDS  = 'cartOfferIds:' + cfg.handle;
    var STORE_HIDE = 'cartOfferHidden:' + cfg.handle;
    var IDS_TTL    = 1000 * 60 * 30;

    var MIN_OVERLAY_W = 200;
    var MIN_OVERLAY_H = 200;
    var MIN_ON_SCREEN = 0.5;

    var idSet = null;
    var hideTimer = null, shimmerTimer = null, cleanupTimer = null, debounceTimer = null;
    var waveTimers = [];
    var lastCount = null;
    var dismissed = false, hasCelebrated = false;
    var wantVisible = false, overlayOpen = false, pendingCelebrate = false;

    var rainLayer = null, rainTimer = null;
    var audioCtx = null;
    var nudgeTimer = null, nudgeClear = null;

    var reduceMotion = false;
    try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

    if (cfg.dismissible && cfg.persist === 'session') {
      try { dismissed = sessionStorage.getItem(STORE_HIDE) === '1'; } catch (e) {}
    }

    /* ---------- helpers ---------- */

    function rand(min, max) { return min + Math.random() * (max - min); }
    function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

    function fillTokens(str, d) {
      return String(str)
        .replace(/\[remaining\]/g, d.remaining)
        .replace(/\[goal\]/g, d.goal)
        .replace(/\[count\]/g, d.count)
        .replace(/\[price\]/g, d.price);
    }

    function setText(node, text) {
      if (!node || node.textContent.trim() === text) return;
      node.textContent = text;
      node.classList.remove('cart-offer-warning--swap');
      void node.offsetWidth;
      node.classList.add('cart-offer-warning--swap');
    }

    function palette() {
      var list = String(cfg.confettiColors)
        .split(',')
        .map(function (c) { return c.trim(); })
        .filter(Boolean);
      return list.length ? list : ['#7c1f2e', '#15855f', '#f0c419'];
    }

    /* ---------- overlay / cart drawer detection ----------

       Shopflo keeps #flo-cart-iframe mounted at full size permanently and
       only moves or layers it away when closed, so size and visibility
       cannot distinguish open from closed. The decisive test is whether
       the element is genuinely on screen AND the topmost thing painted at
       its own centre point.
    ------------------------------------------------------------------- */

    function isRealOverlay(node) {
      if (!node) return false;
      if (node.hasAttribute('hidden')) return false;
      if (node === root || root.contains(node) || node.contains(root)) return false;

      var cs = window.getComputedStyle(node);
      if (cs.display === 'none') return false;
      if (cs.visibility === 'hidden' || cs.visibility === 'collapse') return false;
      if (parseFloat(cs.opacity) < 0.1) return false;
      if (cs.pointerEvents === 'none') return false;

      var r = node.getBoundingClientRect();
      if (r.width < MIN_OVERLAY_W || r.height < MIN_OVERLAY_H) return false;

      var vw = window.innerWidth  || document.documentElement.clientWidth;
      var vh = window.innerHeight || document.documentElement.clientHeight;

      var visW = Math.min(r.right, vw) - Math.max(r.left, 0);
      var visH = Math.min(r.bottom, vh) - Math.max(r.top, 0);
      if (visW <= 0 || visH <= 0) return false;
      if ((visW * visH) / (r.width * r.height) < MIN_ON_SCREEN) return false;

      var cx = Math.min(Math.max(r.left + r.width / 2, 1), vw - 1);
      var cy = Math.min(Math.max(r.top + r.height / 2, 1), vh - 1);

      var top;
      try { top = document.elementFromPoint(cx, cy); }
      catch (e) { return false; }
      if (!top) return false;

      if (!(node === top || node.contains(top) || top.contains(node))) {
        log('not topmost, ignoring:', node.id || node.tagName);
        return false;
      }

      return true;
    }

    function detectOverlay() {
      if (!cfg.hideWhenOverlay || !cfg.overlaySelectors) return false;
      var nodes;
      try { nodes = document.querySelectorAll(cfg.overlaySelectors); }
      catch (e) { return false; }
      for (var i = 0; i < nodes.length; i++) {
        if (isRealOverlay(nodes[i])) {
          log('overlay OPEN:', nodes[i].id || nodes[i].tagName);
          return true;
        }
      }
      return false;
    }

    function checkOverlay() {
      var now = detectOverlay();
      if (now === overlayOpen) return;
      overlayOpen = now;
      log('overlay state ->', now ? 'OPEN' : 'CLOSED');
      syncVisibility();
      if (!now) scheduleRefresh(220);
    }

    /* ---------- visibility ---------- */

    function syncVisibility() {
      var shouldShow = wantVisible && !overlayOpen && !dismissed;
      if (shouldShow) {
        if (root.hasAttribute('hidden')) { root.removeAttribute('hidden'); root.offsetHeight; }
        requestAnimationFrame(function () {
          root.classList.add('cart-offer-popup--visible');
          if (pendingCelebrate) {
            pendingCelebrate = false;
            setTimeout(runCelebration, 320);
          }
        });
      } else {
        root.classList.remove('cart-offer-popup--visible');
      }
    }

    function show() { wantVisible = true;  syncVisibility(); }
    function hide() { wantVisible = false; syncVisibility(); }

    /* ---------- celebration ----------

       Timeline:
         0ms    card pop + halo + burst glow + twin shockwave rings
         0ms    glow ring traces the border, haptic buzz, optional chime
         0ms    main volley, split across front and back depth layers
         0ms    optional fullscreen confetti rain
         200ms  left cannon
         320ms  right cannon
         620ms  slow sparkle motes drift upward
    ------------------------------------------------------------------- */

    function clearWaves() {
      for (var i = 0; i < waveTimers.length; i++) clearTimeout(waveTimers[i]);
      waveTimers = [];
    }

    function buzz() {
      if (!cfg.haptics) return;
      try { if (navigator.vibrate) navigator.vibrate([16, 50, 26, 50, 70]); }
      catch (e) {}
    }

    function playChime() {
      if (!cfg.sound) return;
      try {
        var AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return;
        if (!audioCtx) audioCtx = new AC();
        if (audioCtx.state === 'suspended') audioCtx.resume();

        var vol = Math.min(Math.max(parseFloat(cfg.soundVolume) || 0.25, 0), 1);
        var notes = [523.25, 659.25, 783.99, 1046.5];

        for (var i = 0; i < notes.length; i++) {
          var t = audioCtx.currentTime + i * 0.085;
          var osc = audioCtx.createOscillator();
          var gain = audioCtx.createGain();
          osc.type = 'sine';
          osc.frequency.setValueAtTime(notes[i], t);
          gain.gain.setValueAtTime(0.0001, t);
          gain.gain.linearRampToValueAtTime(vol, t + 0.012);
          gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.42);
          osc.connect(gain);
          gain.connect(audioCtx.destination);
          osc.start(t);
          osc.stop(t + 0.46);
        }
      } catch (e) {}
    }

    function ensureRainLayer() {
      if (rainLayer && document.body.contains(rainLayer)) return rainLayer;
      rainLayer = document.createElement('div');
      rainLayer.className = 'cart-offer-fullscreen';
      rainLayer.setAttribute('aria-hidden', 'true');
      document.body.appendChild(rainLayer);
      return rainLayer;
    }

    function rainConfetti() {
      if (!cfg.fullscreen || reduceMotion) return;

      var layer = ensureRainLayer();
      layer.innerHTML = '';

      var colors = palette();
      var shapes = ['square', 'ribbon', 'disc', 'ribbon'];
      var total = Math.max(10, cfg.fullscreenCount || 70);
      var frag = document.createDocumentFragment();
      var maxDur = 0;

      for (var i = 0; i < total; i++) {
        var shape = shapes[i % shapes.length];

        var piece = document.createElement('span');
        piece.className = 'cart-offer-rain-piece';

        var inner = document.createElement('span');
        inner.className = 'cart-offer-rain-piece__inner';
        piece.appendChild(inner);

        var heavy = (shape === 'disc' || shape === 'square');
        var w, h, radius;
        if (shape === 'ribbon')    { w = rand(4, 7);   h = rand(13, 22); radius = '2px'; }
        else if (shape === 'disc') { w = rand(6, 10);  h = w;            radius = '50%'; }
        else                       { w = rand(6, 11);  h = rand(7, 13);  radius = '1px'; }

        var dur = Math.round(heavy ? rand(2100, 3000) : rand(2600, 3900));
        var delay = Math.round(rand(0, 900));
        if (dur + delay > maxDur) maxDur = dur + delay;

        piece.style.setProperty('--co-origin-x', rand(2, 98).toFixed(2) + '%');
        piece.style.setProperty('--co-drift', Math.round(rand(-90, 90)) + 'px');
        piece.style.setProperty('--co-dur', dur + 'ms');
        piece.style.setProperty('--co-delay', delay + 'ms');

        inner.style.setProperty('--co-w', w.toFixed(1) + 'px');
        inner.style.setProperty('--co-h', h.toFixed(1) + 'px');
        inner.style.setProperty('--co-radius', radius);
        inner.style.setProperty('--co-color', pick(colors));
        inner.style.setProperty('--co-tilt', Math.round(rand(0, 360)) + 'deg');
        inner.style.setProperty('--co-spin', Math.round(heavy ? rand(500, 900) : rand(700, 1350)) + 'ms');

        frag.appendChild(piece);
      }

      layer.appendChild(frag);

      clearTimeout(rainTimer);
      rainTimer = setTimeout(function () {
        if (rainLayer) rainLayer.innerHTML = '';
      }, maxDur + 600);
    }

    function runCelebration() {
      clearWaves();
      clearTimeout(cleanupTimer);

      root.classList.remove('cart-offer-popup--celebrate');
      void root.offsetWidth;
      root.classList.add('cart-offer-popup--celebrate');

      buzz();
      playChime();
      rainConfetti();

      burstConfetti(0.5, 0.44, 1);
      waveTimers.push(setTimeout(function () { burstConfetti(0.14, 0.56, 0.42); }, 200));
      waveTimers.push(setTimeout(function () { burstConfetti(0.86, 0.56, 0.42); }, 320));
      waveTimers.push(setTimeout(releaseMotes, 620));

      waveTimers.push(setTimeout(function () {
        root.classList.remove('cart-offer-popup--celebrate');
      }, 2400));

      cleanupTimer = setTimeout(function () {
        if (el.confettiFront) el.confettiFront.innerHTML = '';
        if (el.confettiBack)  el.confettiBack.innerHTML = '';
      }, (cfg.confettiDuration || 1900) * 1.6 + 1400);
    }

    // originX / originY are 0-1 fractions of the popup box; scale trims count
    function burstConfetti(originX, originY, scale) {
      if (!cfg.confetti || reduceMotion) return;
      if (!el.confettiFront && !el.confettiBack) return;

      var colors = palette();
      var shapes = ['square', 'ribbon', 'disc', 'spark', 'ribbon', 'square'];
      var total = Math.max(8, Math.round((cfg.confettiCount || 62) * (scale || 1)));
      var spread = cfg.confettiSpread || 230;
      var baseDur = cfg.confettiDuration || 1900;

      var fragFront = document.createDocumentFragment();
      var fragBack = document.createDocumentFragment();

      for (var i = 0; i < total; i++) {
        var shape = shapes[i % shapes.length];
        var toBack = el.confettiBack && (i % 5) < 2;   // roughly 40% behind the card

        var piece = document.createElement('span');
        piece.className = 'cart-offer-confetti-piece cart-offer-confetti-piece--' + shape;

        var inner = document.createElement('span');
        inner.className = 'cart-offer-confetti-piece__inner';
        piece.appendChild(inner);

        // Upward launch fan, -172deg to -8deg, with jitter
        var angle = (-172 + (164 * i) / total + rand(-10, 10)) * (Math.PI / 180);
        var power = spread * rand(0.5, 1.2);

        var x1 = Math.cos(angle) * power;
        var y1 = Math.sin(angle) * power * rand(0.68, 1.08);

        // Heavier shapes fall faster and drift less
        var heavy = (shape === 'disc' || shape === 'square');
        var drift = heavy ? rand(1.05, 1.4) : rand(1.3, 1.95);
        var fall  = heavy ? rand(300, 460) : rand(210, 350);

        var x2 = x1 * drift;
        var y2 = Math.abs(y1) + fall;

        var w, h, radius;
        if (shape === 'ribbon')     { w = rand(3.5, 6);  h = rand(14, 22); radius = '2px'; }
        else if (shape === 'disc')  { w = rand(6, 9.5);  h = w;            radius = '50%'; }
        else if (shape === 'spark') { w = rand(10, 15);  h = w;            radius = '0'; }
        else                        { w = rand(6, 10);   h = rand(7, 12);  radius = '1px'; }

        piece.style.setProperty('--co-origin-x', (originX * 100) + '%');
        piece.style.setProperty('--co-origin-y', (originY * 100) + '%');
        piece.style.setProperty('--co-x1', Math.round(x1) + 'px');
        piece.style.setProperty('--co-y1', Math.round(y1) + 'px');
        piece.style.setProperty('--co-x2', Math.round(x2) + 'px');
        piece.style.setProperty('--co-y2', Math.round(y2) + 'px');
        piece.style.setProperty('--co-dur', Math.round(baseDur * (heavy ? rand(0.7, 1) : rand(0.95, 1.35))) + 'ms');
        piece.style.setProperty('--co-delay', Math.round(rand(0, 210)) + 'ms');

        inner.style.setProperty('--co-w', w.toFixed(1) + 'px');
        inner.style.setProperty('--co-h', h.toFixed(1) + 'px');
        inner.style.setProperty('--co-radius', radius);
        inner.style.setProperty('--co-color', pick(colors));
        inner.style.setProperty('--co-tilt', Math.round(rand(0, 360)) + 'deg');
        inner.style.setProperty('--co-spin', Math.round(heavy ? rand(420, 780) : rand(650, 1250)) + 'ms');

        (toBack ? fragBack : fragFront).appendChild(piece);
      }

      if (el.confettiFront) el.confettiFront.appendChild(fragFront);
      if (el.confettiBack)  el.confettiBack.appendChild(fragBack);
    }

    function releaseMotes() {
      if (!cfg.motes || reduceMotion || !el.confettiFront) return;

      var colors = palette();
      var frag = document.createDocumentFragment();
      var total = cfg.moteCount || 14;

      for (var i = 0; i < total; i++) {
        var mote = document.createElement('span');
        mote.className = 'cart-offer-mote';

        var startDrift = rand(-14, 14);
        mote.style.setProperty('--co-origin-x', Math.round(rand(12, 88)) + '%');
        mote.style.setProperty('--co-origin-y', Math.round(rand(55, 95)) + '%');
        mote.style.setProperty('--co-size', rand(3, 6.5).toFixed(1) + 'px');
        mote.style.setProperty('--co-color', pick(colors));
        mote.style.setProperty('--co-drift', Math.round(startDrift) + 'px');
        mote.style.setProperty('--co-drift2', Math.round(startDrift + rand(-30, 30)) + 'px');
        mote.style.setProperty('--co-rise', Math.round(rand(90, 190)) + 'px');
        mote.style.setProperty('--co-dur', Math.round(rand(1700, 2800)) + 'ms');
        mote.style.setProperty('--co-delay', Math.round(rand(0, 700)) + 'ms');

        frag.appendChild(mote);
      }
      el.confettiFront.appendChild(frag);
    }

    window.cartOfferCelebrate = runCelebration;

    /* ---------- idle nudge while the offer is still locked ---------- */

    function startNudge() {
      if (!cfg.nudgeEvery || reduceMotion) return;
      clearInterval(nudgeTimer);
      nudgeTimer = setInterval(function () {
        if (document.hidden) return;
        if (!root.classList.contains('cart-offer-popup--visible')) return;
        if (root.classList.contains('cart-offer-popup--unlocked')) return;
        if (root.classList.contains('cart-offer-popup--celebrate')) return;

        root.classList.remove('cart-offer-popup--nudge');
        void root.offsetWidth;
        root.classList.add('cart-offer-popup--nudge');

        clearTimeout(nudgeClear);
        nudgeClear = setTimeout(function () {
          root.classList.remove('cart-offer-popup--nudge');
        }, 1000);
      }, Math.max(parseInt(cfg.nudgeEvery, 10) || 0, 3000));
    }

    /* ---------- collection product ids ---------- */

    function loadIds() {
      if (idSet) return Promise.resolve(idSet);

      try {
        var raw = sessionStorage.getItem(STORE_IDS);
        if (raw) {
          var c = JSON.parse(raw);
          if (c && Date.now() - c.t < IDS_TTL && Array.isArray(c.ids)) {
            idSet = new Set(c.ids);
            return Promise.resolve(idSet);
          }
        }
      } catch (e) {}

      var ids = [], page = 1;

      function next() {
        return fetch('/collections/' + cfg.handle + '/products.json?limit=250&page=' + page,
                     { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (d) {
            var list = (d && d.products) || [];
            for (var i = 0; i < list.length; i++) ids.push(list[i].id);
            if (list.length === 250 && page < cfg.maxPages) { page++; return next(); }
            return ids;
          })
          .catch(function () { return ids; });
      }

      return next().then(function (all) {
        idSet = new Set(all);
        log('collection ids loaded:', all.length);
        try { sessionStorage.setItem(STORE_IDS, JSON.stringify({ t: Date.now(), ids: all })); } catch (e) {}
        return idSet;
      });
    }

    // Counts UNITS, and pushes one thumbnail per unit, so a single line with
    // quantity 3 fills three slots. Matches the Liquid first paint.
    function countCart(cart) {
      if (!idSet || !idSet.size) return null;
      var n = 0, thumbs = [], items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (!idSet.has(it.product_id)) continue;
        var q = cfg.mode === 'lines' ? 1 : (it.quantity || 0);
        n += q;
        var img = (it.featured_image && it.featured_image.url) || it.image || '';
        for (var k = 0; k < q && thumbs.length < cfg.goal; k++) thumbs.push(img);
      }
      return { count: n, thumbs: thumbs };
    }

    /* ---------- render ---------- */

    function renderSlots(thumbs, pingIndex) {
      if (!el.slots || !cfg.thumbs) return;
      var canPing = cfg.slotPing && !reduceMotion;
      var html = '';
      for (var i = 0; i < cfg.goal; i++) {
        var delay = 'style="animation-delay:' + (i * 70) + 'ms"';
        var ping = (canPing && i === pingIndex) ? ' cart-offer-popup__slot--ping' : '';
        if (thumbs[i]) {
          var src = thumbs[i];
          if (src.indexOf('?') === -1) src += '?width=140';
          html += '<span class="cart-offer-popup__slot cart-offer-popup__slot--filled' + ping + '" ' + delay + '>'
                + '<img src="' + src + '" alt="" width="70" height="70" loading="lazy" decoding="async">'
                + '<span class="cart-offer-popup__slot-check" aria-hidden="true">'
                + '<svg viewBox="0 0 12 12" width="8" height="8" focusable="false">'
                + '<path d="M2.5 6.2 L4.8 8.5 L9.5 3.6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
                + '</svg></span></span>';
        } else {
          html += '<span class="cart-offer-popup__slot cart-offer-popup__slot--empty" ' + delay + '>'
                + '<svg viewBox="0 0 14 14" width="10" height="10" aria-hidden="true" focusable="false">'
                + '<path d="M7 2.6 V11.4 M2.6 7 H11.4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>'
                + '</svg></span>';
        }
      }
      el.slots.innerHTML = html;
    }

    function apply(count, thumbs) {
      if ((cfg.hideOnCart && cfg.isCartPage) || dismissed) { hide(); return; }

      var unlocked = count >= cfg.goal;
      if (count <= 0 || (unlocked && !cfg.showUnlocked)) { hide(); lastCount = count; return; }

      var filled = Math.min(count, cfg.goal);
      var d = {
        count: count,
        goal: cfg.goal,
        remaining: Math.max(cfg.goal - count, 0),
        price: cfg.price
      };
      var advanced = lastCount !== null && count > lastCount;
      var justUnlocked = unlocked && lastCount !== null && lastCount < cfg.goal;

      log('apply — count:', count, 'unlocked:', unlocked);

      root.classList.toggle('cart-offer-popup--unlocked', unlocked);

      setText(el.message, fillTokens(unlocked ? cfg.textUnlocked : cfg.textHeading, d));
      if (el.sub) setText(el.sub, fillTokens(unlocked ? cfg.textSubUnlocked : cfg.textSub, d));

      if (el.count) {
        var nextBadge = filled + '/' + cfg.goal;
        if (cfg.countRoll && !reduceMotion && !justUnlocked && el.count.textContent.trim() !== nextBadge) {
          el.count.classList.remove('cart-offer-popup__badge--roll');
          void el.count.offsetWidth;
          el.count.classList.add('cart-offer-popup__badge--roll');
        }
        el.count.textContent = nextBadge;
      }

      if (el.ctaLabel) setText(el.ctaLabel, fillTokens(unlocked ? cfg.ctaLabelUnlocked : cfg.ctaLabel, d));
      if (el.cta) el.cta.setAttribute('href', unlocked ? cfg.ctaUrlUnlocked : cfg.ctaUrl);

      var pct = Math.round((filled / cfg.goal) * 100);
      root.style.setProperty('--cart-offer-pct', pct + '%');
      if (el.bar) el.bar.setAttribute('aria-valuenow', filled);

      if (advanced && el.fill) {
        clearTimeout(shimmerTimer);
        el.fill.classList.remove('is-advancing');
        void el.fill.offsetWidth;
        el.fill.classList.add('is-advancing');
        shimmerTimer = setTimeout(function () { el.fill.classList.remove('is-advancing'); }, 1000);
      }

      if (thumbs && count !== lastCount) renderSlots(thumbs, advanced ? filled - 1 : -1);

      clearTimeout(hideTimer);
      show();

      if (justUnlocked && !hasCelebrated) {
        hasCelebrated = true;
        if (overlayOpen) pendingCelebrate = true;
        else setTimeout(runCelebration, 200);
      }
      if (!unlocked) { hasCelebrated = false; pendingCelebrate = false; }

      if (unlocked && cfg.autohide > 0) {
        hideTimer = setTimeout(hide, cfg.autohide);
      }

      lastCount = count;
    }

    function refresh() {
      return loadIds()
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var res = countCart(cart);
          if (res) apply(res.count, res.thumbs);
        })
        .catch(function () {});
    }

    function scheduleRefresh(delay) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(refresh, delay || 260);
    }

    /* ---------- listeners ---------- */

    if (cfg.hideWhenOverlay) {
      checkOverlay();
      setInterval(checkOverlay, cfg.overlayPoll || 350);
      document.addEventListener('click', function () { setTimeout(checkOverlay, 80); }, true);
      window.addEventListener('keyup', function (e) {
        if (e.key === 'Escape') setTimeout(checkOverlay, 120);
      });
      window.addEventListener('blur',  function () { setTimeout(checkOverlay, 120); });
      window.addEventListener('focus', function () { setTimeout(checkOverlay, 120); });
    }

    if (el.close) {
      el.close.addEventListener('click', function () {
        dismissed = true;
        hide();
        if (cfg.persist === 'session') {
          try { sessionStorage.setItem(STORE_HIDE, '1'); } catch (e) {}
        }
      });
    }

    var CART_RE = /\/cart\/(add|change|update|clear)/i;

    var origFetch = window.fetch;
    if (typeof origFetch === 'function') {
      window.fetch = function () {
        var url = '';
        try {
          url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
        } catch (e) {}
        var p = origFetch.apply(this, arguments);
        if (CART_RE.test(url)) p.then(function () { scheduleRefresh(); }).catch(function () {});
        return p;
      };
    }

    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__cartOfferWatch = CART_RE.test(String(url || ''));
      return origOpen.apply(this, arguments);
    };

    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__cartOfferWatch) {
        this.addEventListener('load', function () { scheduleRefresh(); });
      }
      return origSend.apply(this, arguments);
    };

    ['cart:updated', 'cart:refresh', 'cart:change', 'variant:added', 'product:added']
      .forEach(function (evt) {
        document.documentElement.addEventListener(evt, function () { scheduleRefresh(120); });
        document.addEventListener(evt, function () { scheduleRefresh(120); });
      });

    document.addEventListener('shopify:section:load', function () { scheduleRefresh(120); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) scheduleRefresh(0); });

    /* ---------- first paint ---------- */

    var initial = parseInt(((el.count && el.count.textContent) || '0').split('/')[0], 10) || 0;
    if (initial > 0 && !dismissed && !(cfg.hideOnCart && cfg.isCartPage)) {
      lastCount = initial;
      if (initial >= cfg.goal) hasCelebrated = true;
      setTimeout(show, cfg.animDelay);
      if (initial >= cfg.goal && cfg.autohide > 0) {
        hideTimer = setTimeout(hide, cfg.animDelay + cfg.autohide);
      }
    }

    startNudge();
    scheduleRefresh(400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();